import React from "react"

import NewsCard from "./NewsCard"
import { CircularProgress } from "@mui/material"
import Stack from "@mui/material/Stack"
import Divider from "@mui/material/Divider"

import "./NewsComponent.css"

import { db } from "../../firebase/firebase_config"
import { collection, getDocs, orderBy, limit, query } from "firebase/firestore"

class NewsComponent extends React.Component {
	state = {
		loading: true,
		news: {},
	}

	async componentDidMount() {
		const news_ret = await this.getNewsData()
		this.setState({ loading: false, news: news_ret })
	}

	getNewsData = async () => {
		let newsList = []
		try {
			const newsCollection = collection(db, "News")
			const q = query(newsCollection, orderBy("DATE", "desc"), limit(3))
			await getDocs(q).then((snapshot) => {
				snapshot.forEach((doc) => {
					newsList.push({ ...doc.data(), id: doc.id })
				})
			})
		} catch (error) {
			console.log("Error fetching firestore data: " + error.message)
		}
		//console.log(newsList)
		return newsList
	}
	render() {
		let newsComponents = <div>Adquiring data...</div>
		if (!this.state.loading) {
			newsComponents = this.state.news.map((n) => (
				<NewsCard key={n.id} data={n} />
			))
		}
		return (
			<div className="news-component-container">
				{this.state.loading ? (
					<CircularProgress />
				) : (
					<Stack
						direction="column"
						spacing={2}
						divider={<Divider orientation="horizontal" flexItem />}
					>
						{newsComponents}
					</Stack>
				)}
			</div>
		)
	}
}

export default NewsComponent
